<div mat-dialog-title style="margin:0px;">{{dialogTitle}}</div>
<mat-dialog-content style="margin-top: 15px;">
    <tyl-form-field label="Identification Code" style="margin-left: 26px;width: 19vw;">
        <mat-select [ngModel]="selectedDataId" (ngModelChange)="selectedDataId = $event; dropDownChange()" name="code"
            id="Identification">
            <mat-option id="identification{{i}}" *ngFor="let item of getIdentificationData;let i = index;"
                [value]="item.DataId">
                <span>{{item.Description}}</span>
            </mat-option>
        </mat-select>
    </tyl-form-field>

    <tyl-form-field label="DualIdentification Code" style="margin-left: 26px;width: 19vw;">
        <mat-select [ngModel]="dualSelectedDataId" (ngModelChange)="dualSelectedDataId = $event; dropDownChange()"
            name="dualcode" id="DualIdentification">
            <mat-option id="dualIdentification{{i}}" *ngFor="let item of getIdentificationData;let i = index;"
                [value]="item.DataId">
                <span>{{item.Description}}</span>
            </mat-option>
        </mat-select>
    </tyl-form-field>

    <tyl-form-field *ngIf="this.stateCode == 'OR' || this.stateCode == 'NM'" label="TertiaryIdentification Code"
        style="margin-left: 26px;width: 19vw;">
        <mat-select [ngModel]="tertiarySelectedDataId"
            (ngModelChange)="tertiarySelectedDataId = $event; dropDownChange()" name="thirdcode"
            id="TertiaryIdentification">
            <mat-option id="thrdIdentification{{i}}" *ngFor="let item of getIdentificationData;let i = index;"
                [value]="item.DataId">
                <span>{{item.Description}}</span>
            </mat-option>
        </mat-select>
    </tyl-form-field>

    <tyl-form-field *ngIf="this.stateCode == 'OR' || this.stateCode == 'NM'" label="QuaternaryIdentification Code"
        style="margin-left: 26px;width: 19vw;">
        <mat-select [ngModel]="quaternarySelectedDataId"
            (ngModelChange)="quaternarySelectedDataId = $event; dropDownChange()" name="fourthcode"
            id="QuaternaryIdentification">
            <mat-option id="fourthIdentification{{i}}" *ngFor="let item of getIdentificationData;let i = index;"
                [value]="item.DataId">
                <span>{{item.Description}}</span>
            </mat-option>
        </mat-select>
    </tyl-form-field>

    <tyl-form-field *ngIf="this.stateCode == 'OR'" label="FifthIdentification Code"
        style="margin-left: 26px;width: 19vw;">
        <mat-select [ngModel]="fifthSelectedDataId" (ngModelChange)="fifthSelectedDataId = $event; dropDownChange()"
            name="fifthcode" id="FifthIdentification">
            <mat-option id="fifthIdentification{{i}}" *ngFor="let item of getIdentificationData;let i = index;"
                [value]="item.DataId">
                <span>{{item.Description}}</span>
            </mat-option>
        </mat-select>
    </tyl-form-field>
    <div style="display:flex;" *ngIf="getIdentificationSubCodeGrid.length == 0">
        <div style="display:flex;; padding-left: 30px;">
            <mat-divider style=" margin-top: 20px;">
            </mat-divider>
            <span style="padding-top: 8px;">
                There are no data records to display.
            </span>
        </div>
    </div>
    <div class="flex-content" style="height: 100%;" *ngIf="getIdentificationSubCodeGrid.length > 0">
        <div style="overflow:auto;">
            <mat-table #tableContainerRef [dataSource]="tylerMatData" multiTemplateDataRows>
                <ng-container matColumnDef="Code">
                    <mat-header-cell *matHeaderCellDef>
                        <span translate>Code</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let detail">
                        {{detail.Code}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Description">
                    <mat-header-cell *matHeaderCellDef>
                        <span translate>Description</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let detail">
                        {{detail.Description}}
                    </mat-cell>
                </ng-container>
                <mat-header-row *matHeaderRowDef="columnToDisplay; sticky: true" id="identificationdata">
                </mat-header-row>
                <mat-row *matRowDef="let row; columns: columnToDisplay; let i = index;" id="identificationRow{{i}}"
                    tabindex="0" style="padding:0px;overflow:hidden;border-bottom-width:1px;" matRipple
                    class="element-row">
                </mat-row>
            </mat-table>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions>
    <div class="flex-footer">
        <div class="flex-footer-right">
            <tyl-button id="saveButton" (clickEvent)="saveClick()" image="save.png" label="Save"></tyl-button>
            <tyl-button id="cancelButton" image="cancel.png" label="Cancel" (clickEvent)="closeClick()"></tyl-button>
        </div>
    </div>
</mat-dialog-actions>